
import React from 'react';

function Menu() {
 return (
   <nav className="w-full bg-gray-700 mt-3">
     <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-1 px-2 py-3 lg:max-w-3xl lg:mx-auto">
       <a href="/" className="text-white text-sm sm:text-base" aria-current="page">Home</a>
       <a href="/bio" className="text-white text-sm sm:text-base">Bio</a>
       <a href="/gallery" className="text-white text-sm sm:text-base">Gallery</a>
       <a href="/media" className="text-white text-sm sm:text-base">Media</a>
       <a href="/blog" className="text-white text-sm sm:text-base">Blog</a>
       <a href="/contact" className="text-white text-sm sm:text-base">Contact</a>
     </div>
   </nav>
 );
}
export default Menu;